import { cn, Div, Span } from '@scatterlab/zeta-core';
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  createElement,
  ElementType,
  memo,
  RefAttributes,
} from 'react';

import { ImageMultipleIcon, VolumeOnFill16Icon } from '../icons';
import LinearGradient from '../LinearGradient';

export type FeatureTagProps<Component extends ElementType = typeof Span> =
  ComponentPropsWithoutRef<Component> &
    RefAttributes<ComponentRef<Component>> & {
      component?: Component;
      ttsSupported?: boolean;
      facialSupported?: boolean;
    };

const FeatureTag = <Component extends ElementType = typeof Span>({
  label,
  className,
  component,
  ttsSupported,
  facialSupported,
  ...props
}: FeatureTagProps<Component>) =>
  createElement(
    component ?? Div,
    {
      title: label,
      ...props,
      className: cn('flex flex-row', className),
    },
    ttsSupported && (
      <Div
        className={cn(
          'flex size-[18px] items-center justify-center rounded-l-[6px] bg-gray-700',
          facialSupported ? '' : 'rounded-r-[6px]',
        )}
      >
        <VolumeOnFill16Icon className="size-[13px] text-white" />
      </Div>
    ),
    facialSupported && (
      <LinearGradient
        className={cn(
          'flex size-[18px] items-center justify-center rounded-r-[6px] bg-gradient-to-br from-[#E700FC] to-[#F73]',
          ttsSupported ? '' : 'rounded-l-[6px]',
        )}
      >
        <ImageMultipleIcon className="size-3 text-white" />
      </LinearGradient>
    ),
  );

export default memo(FeatureTag) as typeof FeatureTag;
